"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgMicrophone32 = function SvgMicrophone32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0c-2.639 0-4.423.88-5.54 2.108C9.372 3.305 9 4.743 9 5.75v9.5c0 1.007.372 2.445 1.46 3.642C11.577 20.119 13.361 21 16 21c2.639 0 4.423-.88 5.54-2.108C22.628 17.695 23 16.257 23 15.25v-9.5c0-1.007-.372-2.445-1.46-3.642C20.423.881 18.639 0 16 0zm-2.4 5.278h-2.557c.095-.547.357-1.23.897-1.824C12.623 2.703 13.839 2 16 2c2.162 0 3.377.703 4.06 1.454.54.594.802 1.277.897 1.824H18.4a1 1 0 100 2H21V9.5h-2.6a1 1 0 100 2H21v2.222h-2.6a1 1 0 100 2h2.557a3.677 3.677 0 01-.897 1.824C19.377 18.297 18.162 19 16 19s-3.377-.703-4.06-1.454a3.677 3.677 0 01-.897-1.824H13.6a1 1 0 100-2H11V11.5h2.6a1 1 0 100-2H11V7.278h2.6a1 1 0 100-2z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M7 14a1 1 0 10-2 0c0 1.925.537 4.647 2.192 6.917 1.557 2.136 4.056 3.8 7.808 4.05V31a1 1 0 102 0v-6.033c3.752-.25 6.25-1.914 7.808-4.05C26.463 18.647 27 15.925 27 14a1 1 0 10-2 0c0 1.617-.463 3.894-1.808 5.739C21.884 21.533 19.686 23 16 23c-3.687 0-5.884-1.467-7.192-3.261C7.463 17.894 7 15.617 7 14z",
    fill: "currentColor"
  }));
};

SvgMicrophone32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgMicrophone32;
exports.default = _default;